export const GROUPS_KEYS = Object.freeze({
  allGroups: 'allGroups',
  orderRemotesGroups: 'orderRemotesGroups',
  propertyGroups: 'propertyGroups',
});
